module.exports = __webpack_public_path__ + "img/solomon-islands.324ac7e5.svg";